import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { createCommand } from './plugin-factory';
export var removeSelectionCommand = function removeSelectionCommand(_ref) {
  var aiSmartButtonOptions = _ref.aiSmartButtonOptions;
  return createCommand(function (state) {
    return true;
  }, function (tr, state) {
    aiSmartButtonOptions === null || aiSmartButtonOptions === void 0 || aiSmartButtonOptions.actions.removeContext();
    var head = state.selection.head;
    tr.setSelection(TextSelection.create(state.doc, head, head));
    return tr;
  });
};